import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';

const BundleHeader = ({ title }) => (
    <Text
        is='h2'
        fontWeight='bold'
        fontSize={['lg-bg', 'xl']}
        lineHeight='tight'
    >
        {title}
    </Text>
);

export default wrapFunctionalComponent(BundleHeader, 'BundleHeader');
